export const PromotionTypes = {
  BUY_X_PAY_Y: "BuyXPayY",
  PROGRESSIVE_DISCOUNT: "ProgressiveDiscount",
  BUY_2_PAY_1: "2x1",
  BUY_3_PAY_2: "3x2",
  CROSS_SELLING: "CrossSelling",
  PERCENTAGE_OFF: "%off",
} as const;

export type PromotionType = typeof PromotionTypes[keyof typeof PromotionTypes];
